import styled from "styled-components"

export interface SelectButtonProps {
  outline: boolean
  disabled: boolean
  onClick?: (props: unknown) => void | Promise<void>
  onKeyDown?: (event: KeyboardEvent) => void
}

export const SelectButtonLabelWithInput = styled.label.attrs(() => ({
  tabIndex: 0,
  role: "button"
}))<SelectButtonProps>(
  ({ outline }) => ({
    padding: "12px 8px 8px 8px",
    background: "white",
    textAlign: "left",
    fontFamily: '"Gotham A", "Gotham B", sans-serif',
    fontSize: "14px",
    lineHeight: "150%",
    borderRadius: "20px",
    border: `2px solid ${outline ? "#E48400" : "#e4840000"}`,
    cursor: "pointer",
    width: "100%"
  }),
  ({ disabled, outline }) =>
    disabled && {
      color: "#CCCCCC",
      cursor: "not-allowed",
      background: "#F5F5F5",
      border: `2px solid ${outline ? "#CCCCCC" : "#F5F5F5"}`,
      ":focus,:hover": {
        background: "#F5F5F5"
      }
    }
)

export const ButtonLabelInput = styled.input`
  background: rgb(245, 245, 245);
  border-radius: 12px;
  outline: none;
  border: none;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 24px;
  appearance: none;
  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`

export const SelectButtonLabel = styled.label.attrs({
  tabIndex: 0,
  role: "button"
})<SelectButtonProps>(
  ({ outline }) => ({
    padding: "8px 32px",
    background: "white",
    textAlign: "left",
    fontFamily: '"Gotham A", "Gotham B", sans-serif',
    fontSize: "16px",
    lineHeight: "150%",
    borderRadius: "20px",
    border: `2px solid ${outline ? "#E48400" : "#e4840000"}`,
    cursor: "pointer",
    ":focus,:hover": {
      background: "#f9ead5"
    }
  }),
  ({ disabled, outline }) =>
    disabled && {
      color: "#CCCCCC",
      cursor: "not-allowed",
      background: "#F5F5F5",
      border: `2px solid ${outline ? "#CCCCCC" : "#F5F5F5"}`,
      ":focus,:hover": {
        background: "#F5F5F5"
      }
    }
)

export const SelectButton = styled.button<SelectButtonProps>(({ outline }) => ({
  padding: "8px 32px",
  background: "white",
  textAlign: "left",
  fontFamily: '"Gotham A", "Gotham B", sans-serif',
  fontSize: "16px",
  lineHeight: "150%",
  borderRadius: "20px",
  border: `2px solid ${outline ? "#E48400" : "#e4840000"}`,
  cursor: "pointer",
  ":focus,:hover": {
    background: "#f9ead5"
  },
  ":disabled": {
    color: "#CCCCCC",
    cursor: "not-allowed",
    background: "#F5F5F5",
    border: `2px solid ${outline ? "#CCCCCC" : "#F5F5F5"}`,
    ":focus,:hover": {
      background: "#F5F5F5"
    }
  }
}))
